import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=4c811b46"
import script from "./Crear.vue?vue&type=script&lang=js"
export * from "./Crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c811b46')) {
      api.createRecord('4c811b46', component.options)
    } else {
      api.reload('4c811b46', component.options)
    }
    module.hot.accept("./Crear.vue?vue&type=template&id=4c811b46", function () {
      api.rerender('4c811b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/area/Crear.vue"
export default component.exports